import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import config from 'teacher-ui-client/config/environment'
import {
  InlineAlert,
  AlertType,
  InlineAlertSubtitle,
  InlineAlertTitle,
} from 'teacher-ui-client/components/inline-alert'

const MAX_STUDENTS_PER_CLASS = config.copyClasses.maxStudentsPerClass

interface Signature {
  Element: HTMLDivElement
  Args: {
    show: boolean
  }
}
export const ClassStudentLimitAlert: TOC<Signature> = <template>
  {{#if @show}}
    <InlineAlert data-test-class-student-limit-alert @type={{AlertType.Critical}}>
      <InlineAlertTitle>
        {{t "components.copyClasses.classStudentLimit.problem"}}
      </InlineAlertTitle>
      <InlineAlertSubtitle>
        {{t "components.copyClasses.classStudentLimit.solution" limit=MAX_STUDENTS_PER_CLASS}}
      </InlineAlertSubtitle>
    </InlineAlert>
  {{/if}}
</template>
